(() => {
  if (customElements.get('raretcg-service-disclosure')) return;

  class RareTCGServiceDisclosure extends HTMLElement {
    connectedCallback() {
      if (this.dataset.rtcgDisclosureReady === 'true') return;

      this.trigger = this.querySelector('[aria-controls]');
      this.panel = this.trigger
        ? this.querySelector(`#${CSS.escape(this.trigger.getAttribute('aria-controls'))}`)
        : null;

      if (!this.trigger || !this.panel) return;

      this.controller = new AbortController();
      const { signal } = this.controller;

      this.dataset.rtcgDisclosureReady = 'true';
      this.close({ restoreFocus: false });

      this.trigger.addEventListener('click', () => this.toggle(), { signal });
      this.addEventListener('keydown', (event) => this.onKeydown(event), { signal });
      document.addEventListener('pointerdown', (event) => this.onOutsidePointer(event), { signal });
      document.addEventListener('focusin', (event) => this.onOutsideFocus(event), { signal });
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      delete this.dataset.rtcgDisclosureReady;
    }

    get isOpen() {
      return this.trigger?.getAttribute('aria-expanded') === 'true';
    }

    open() {
      if (!this.trigger || !this.panel || this.isOpen) return;

      this.panel.hidden = false;
      this.classList.add('is-open');
      this.trigger.setAttribute('aria-expanded', 'true');
    }

    close({ restoreFocus = false } = {}) {
      if (!this.trigger || !this.panel) return;

      this.panel.hidden = true;
      this.classList.remove('is-open');
      this.trigger.setAttribute('aria-expanded', 'false');

      if (restoreFocus) this.trigger.focus();
    }

    toggle() {
      this.isOpen ? this.close() : this.open();
    }

    onKeydown(event) {
      if (
        event.target === this.trigger &&
        (event.key === 'Enter' || event.key === ' ')
      ) {
        event.preventDefault();
        this.toggle();
        return;
      }

      if (event.key !== 'Escape' || !this.isOpen) return;

      event.preventDefault();
      event.stopPropagation();
      this.close({ restoreFocus: true });
    }

    onOutsidePointer(event) {
      if (this.isOpen && !this.contains(event.target)) {
        this.close();
      }
    }

    onOutsideFocus(event) {
      if (this.isOpen && !this.contains(event.target)) {
        this.close();
      }
    }
  }

  customElements.define('raretcg-service-disclosure', RareTCGServiceDisclosure);

  document.addEventListener('click', (event) => {
    const label = event.target.closest('[data-rtcg-wishlist-label]');
    if (!label) return;

    const wrap = label.closest('.raretcg-top-service-bar__wishlist');
    const target = wrap?.querySelector(
      '.raretcg-top-service-bar__wishlist-app a, .raretcg-top-service-bar__wishlist-app button'
    );

    target?.click();
  });
})();
